import { render, staticRenderFns } from "./DataSnackbar.vue?vue&type=template&id=17771c66&scoped=true"
import script from "./DataSnackbar.vue?vue&type=script&lang=js"
export * from "./DataSnackbar.vue?vue&type=script&lang=js"
import style0 from "./DataSnackbar.vue?vue&type=style&index=0&id=17771c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17771c66",
  null
  
)

export default component.exports